'use client'

import { Button, Divider, Modal } from '@mantine/core'
import { APP_NAME } from '@partment/types'
import {
  RiCheckLine,
  RiFileCopyLine,
  RiHeadphoneLine,
  RiWhatsappLine,
} from '@remixicon/react'
import dynamic from 'next/dynamic'
import { useState } from 'react'

const ScheduleCallPopup = dynamic(
  () => import('../ScheduleCallPopup').then((mod) => mod.ScheduleCallPopup),
  {
    ssr: false,
  },
)

interface ContactSupportPopupProps {
  opened: boolean
  onClose: () => void
  appName?: APP_NAME
}

export function ContactSupportPopup({
  opened,
  onClose,
  appName = APP_NAME['CO-OWNER'],
}: ContactSupportPopupProps) {
  const phoneNumber =
    appName === APP_NAME['CO-OWNER']
      ? '+20-103-0110692'
      : appName === APP_NAME.RENTAL_MARKETPLACE
        ? '+20-101-7908546'
        : ''
  const whatsAppLink =
    appName === APP_NAME['CO-OWNER']
      ? 'https://api.whatsapp.com/send/?phone=201030110692&text&type=phone_number&app_absent=0'
      : appName === APP_NAME.RENTAL_MARKETPLACE
        ? 'http://wa.me/201017908546'
        : ''
  const [copied, setCopied] = useState(false)
  const [shedulcall, setShedulcall] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(phoneNumber)
      setCopied(true)
      // reset message after 2 seconds
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }
  return (
    <>
      <Modal
        opened={opened}
        onClose={onClose}
        centered
        withCloseButton
        radius='16px'
        size='md'
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            padding: '20px',
          }}
        >
          <div
            style={{
              width: '50px',
              height: '50px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
              backgroundColor: '#F1F1F2',
              marginBottom: '10px',
            }}
          >
            <RiHeadphoneLine size={24} color='#1F2021' />
          </div>

          <h2
            style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#101828',
              marginBottom: '10px',
              lineHeight: '28px',
            }}
          >
            Need help?
          </h2>
          <p
            style={{
              fontSize: '14px',
              color: '#101828',
              marginBottom: '10px',
              lineHeight: '23px',
            }}
          >
            You can reach our support team anytime through the options below.
            We'll be happy to assist you.
          </p>

          {phoneNumber !== '' && (
            <div
              style={{
                width: '100%',
                backgroundColor: '#F1F1F2',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '10px',
              }}
            >
              <p
                style={{
                  fontSize: '15px',
                  fontWeight: '600',
                  color: '#101828',
                }}
              >
                Call us directly
              </p>
              <p
                style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  color: '#101828',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                }}
              >
                <span>{phoneNumber}</span>
                {copied ? (
                  <RiCheckLine size={16} />
                ) : (
                  <RiFileCopyLine
                    size={16}
                    onClick={handleCopy}
                    className='cursor-pointer'
                  />
                )}
              </p>
            </div>
          )}

          {phoneNumber !== '' && (
            <Divider my='xs' label='or' labelPosition='center' w='100%' />
          )}

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px',
              width: '100%',
              marginTop: '10px',
            }}
          >
            {whatsAppLink !== '' && (
              <Button
                fullWidth
                leftSection={<RiWhatsappLine size={16} color='#4FAC79' />}
                variant='outline'
                color='#4FAC79'
                component='a'
                href={whatsAppLink}
                target='_blank'
                radius={8}
                fz='xs'
                flex={1}
              >
                WhatsApp Chat
              </Button>
            )}

            <Button
              fullWidth
              onClick={() => {
                onClose()
                setShedulcall(true)
              }}
              leftSection={<RiHeadphoneLine size={16} color='#FFFFFF' />}
              color='#4FAC79'
              variant='filled'
              radius={8}
              style={{
                backgroundColor: '#4FAC79',
                color: '#FFFFFF',
                fontSize: '13px',
                fontWeight: '500',
              }}
              fz='xs'
              flex={1}
            >
              Schedule a Call
            </Button>
          </div>
        </div>
      </Modal>
      {shedulcall && (
        <ScheduleCallPopup opened={shedulcall} setOpened={setShedulcall} />
      )}
    </>
  )
}
